import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { targetIcon } from '../../icons';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';

export const Autobroker = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('autobroker-error-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ErrorWrapper icon={targetIcon}>Вы не&nbsp;можете делать ставку, пока включена автостратегия</ErrorWrapper>;
};
